import React from 'react';
import {Link} from 'react-router-dom';

const LinkCustom = ({label, link, fontSize = 14, fontWeight = "Regular"}) => (
    <Link to={link} className={`link-to font-size${fontSize} ${fontWeight}`}>{label}</Link>
);

export default LinkCustom;